import { OrderRoutes } from "./OrderRoutes";
import { PaymentRoutes } from "./PaymentRoutes";

type CheckoutRoutesConfiguration = {
  isFreeTrial?: boolean;
};

export class CheckoutRoutes {
  readonly root: string;
  readonly shipping: string;
  readonly delivery: string;
  readonly payment: PaymentRoutes;
  readonly order: OrderRoutes;

  constructor(config: CheckoutRoutesConfiguration | undefined = {}) {
    const basePath = config.isFreeTrial ? "/trial/" : "/";

    this.root = basePath;
    this.shipping = `${this.root}shipping`;
    this.delivery = `${this.root}delivery`;
    this.payment = new PaymentRoutes(basePath);
    this.order = new OrderRoutes(basePath);
  }
}
